//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      currentSelection: this.options[0],
    };
  },
  props: {
    options: {
      default: () => {
        return ["All", "Latin", "Standard", "Smooth", "Rhythm"];
      },
    },
  },
  methods: {
      setFilter(selection) {
          this.currentSelection = selection
          this.$emit('setFilter', selection)
      }
  },
};
